import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MAPS_EXPORT_MAP_ASSET_TYPE, MAPS_EXPORT_INFO_ASSET_TYPE, MATERIAL_THUMBNAIL_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "teknion" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_NAME$",
    },

    // maps exports maps
    {
        type: MAPS_EXPORT_MAP_ASSET_TYPE,
        schema: "$MATERIAL_NAME$-$MAP_TYPE$.$EXPORT_FORMAT$",
        options,
    },

    // maps exports info
    {
        type: MAPS_EXPORT_INFO_ASSET_TYPE,
        schema: "$MATERIAL_NAME$-info.$INFO_FILE_FORMAT$",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_NAME$.$IMAGE_FORMAT$",
        options,
    },

    // thumbnails
    ...MATERIAL_THUMBNAIL_TYPE.map((type) => ({
        type,
        schema: "$MATERIAL_NAME$.$IMAGE_FORMAT$",
        options,
    })),
]
